var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.fileAvailable)?_c('a',{attrs:{"href":_vm.urls.download}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',[_vm._v(" None ")])
}
var staticRenderFns = []

export { render, staticRenderFns }